import { render, staticRenderFns } from "./LinhaDeParcela.vue?vue&type=template&id=4fcbfffe&scoped=true"
import script from "./LinhaDeParcela.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeParcela.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeParcela.vue?vue&type=style&index=0&id=4fcbfffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcbfffe",
  null
  
)

export default component.exports